module.exports = __webpack_public_path__ + "img/asm0002.asm.d7a2fd65.jpg";